import React from 'react'
import "./App.css";
import Navbar from './Components/Navbar Menu';
function App() {
  return (
    <div className="App">
      <Navbar />
    </div>
  );
}

export default App;
